import { render, staticRenderFns } from "./503.vue?vue&type=template&id=5a6f63d8&scoped=true"
var script = {}
import style0 from "./503.vue?vue&type=style&index=0&id=5a6f63d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6f63d8",
  null
  
)

export default component.exports